function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

var _events = /*#__PURE__*/_classPrivateFieldLooseKey("events");

export class Pubsub {
  constructor() {
    Object.defineProperty(this, _events, {
      writable: true,
      value: {}
    });
    _classPrivateFieldLooseBase(this, _events)[_events] = {};
  }

  on(event, listener) {
    if (!_classPrivateFieldLooseBase(this, _events)[_events][event]) {
      _classPrivateFieldLooseBase(this, _events)[_events][event] = [];
    }

    _classPrivateFieldLooseBase(this, _events)[_events][event].push(listener);

    return () => {
      var _classPrivateFieldLoo;

      _classPrivateFieldLooseBase(this, _events)[_events][event] = ((_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _events)[_events][event]) == null ? void 0 : _classPrivateFieldLoo.filter(fn => fn !== listener)) || [];
    };
  }

  publish(event, data) {
    var _classPrivateFieldLoo2;

    if (!(event in _classPrivateFieldLooseBase(this, _events)[_events])) {
      return;
    }

    (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(this, _events)[_events][event]) == null ? void 0 : _classPrivateFieldLoo2.forEach(listener => {
      listener(data);
    });
  }

  cleanAll() {
    _classPrivateFieldLooseBase(this, _events)[_events] = {};
  }

  clean(event) {
    _classPrivateFieldLooseBase(this, _events)[_events][event] = undefined;
  }

}
//# sourceMappingURL=pubsub.js.map